import { UNIVERSITYPLAN } from '../../utility/enums/planType';
import defaultSectionTitle from './defaultSectionTitle';

export default ({
  selectedPlan = null,
  universityPlan = null,
  sectionKey = null,
}) => {
  if (!sectionKey) return null;
  if (
    selectedPlan &&
    selectedPlan === UNIVERSITYPLAN &&
    universityPlan &&
    universityPlan.code &&
    defaultSectionTitle[universityPlan.code] &&
    defaultSectionTitle[universityPlan.code][sectionKey]
  ) {
    return defaultSectionTitle[universityPlan.code][sectionKey];
  }
  return defaultSectionTitle.DEFAULT[sectionKey];
};
